<div class="context-menu p-2" [style.left.px]="position.x" [style.top.px]="position.y">
  <p class="lead p-2 ps-3 m-0 text-center border-bottom">Shelf Options</p>

  <!-- Navigation -->
  <button (click)="openDropMenu.emit('openDropMenu')">Drop Menu</button>

  <!-- Add -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('add', $event)">
      Add <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'add'">
      <button (click)="addShelfAbove.emit('addAbove')" [disabled]="!canEdit">Add Shelf Above</button>
      <button (click)="addShelfBelow.emit('addBelow')" [disabled]="!canEdit">Add Shelf Below</button>
    </div>
  </div>

  <!-- Copy / Paste -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('copy', $event)">
      Copy / Paste <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'copy'">
      <button (click)="copyShelf.emit('copy')">Copy Shelf</button>
      <button (click)="pasteAboveShelf.emit('pasteAbove')" [disabled]="!canEdit">Paste Above</button>
      <button (click)="pasteBelowShelf.emit('pasteBelow')" [disabled]="!canEdit">Paste Below</button>
    </div>
  </div>

  <!-- Remove -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('remove', $event)">
      Remove / Clear <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'remove'">
      <button (click)="removeShelf.emit('remove')" [disabled]="!canEdit">Remove Shelf</button>
      <button (click)="clearShelf.emit('clear')" [disabled]="!canEdit">Clear Shelf</button>
    </div>
  </div>
</div>